/**
 * @description
 *
 * Here you should declare the state properties and it's initial values
 * @return {object} with state data
 */
const initialState = () => {
    return {
        token: localStorage.getItem('user-token') || '',
        status: '',
        user: localStorage.getItem('user'),
        hasLoadedOnce: false,
        posWorkstationType:
            JSON.parse(localStorage.getItem('pos_workstation_type')) || '',
        groundSeller: JSON.parse(localStorage.getItem('ground_seller')),
    }
}

export default initialState
